module.exports = __webpack_public_path__ + "img/img47.75a390ed.png";